// 获取消息列表
export var getMessage = {
  'merchant': '/rest/merchant/apicenter/notify/message/get',
  'llsp': '/rest/sp/message/center/getMessageList'
};

// 标记已读
export var markMsgRead = {
  'merchant': '/rest/merchant/apicenter/notify/markMsgRead',
  'llsp': '/rest/sp/message/center/markMessageRead'
};
// 一键标记已读
export var markAllMsgRead = {
  'merchant': '/rest/merchant/apicenter/notify/markAllMsgRead',
  'llsp': '/rest/sp/message/center/markAllMessageRead'
};
// 获取platform下的所有可展示一级label
export var getPrimaryLabel = {
  'merchant': '/rest/merchant/apicenter/notify/primaryLabel/get',
  'llsp': '/rest/sp/message/center/getMsgPrimaryLabelList'
};
export var getUnreadCountInfo = {
  'merchant': '/rest/merchant/apicenter/notify/unreadCountInfo/get',
  'llsp': '/rest/sp/message/center/getMessageLabelUnreadCount'
};